@if (documents && documents.length > 0) {
<div class="{{colsDefn}} my-2">
    @if (showHeader) {

    <ng-container *ngTemplateOutlet="pluralheading; context: {$implicit: documents, heading: 'SOURCE DOCUMENT', classes: 'column-header'}"></ng-container>

    }
    <table class="table table-borderless definitions w-100 one-line-first-column">
        <thead>
            <tr>
                <th></th>
                <th>Title</th>
            </tr>
        </thead>
        <tbody>
            @for (docket of documents; track docket) {

            <tr>
                <td>{{ docket.Date | date}}</td>
                <td>
                    <p class="m-0">{{ unwrapJSONString(docket.Name) }}</p>
                    <ul class="list-unstyled">
                        @for (document of docket.documents; track document) {

                        <li>
                            <pdf-viewer [document]="document">
                                {{ document.description }}
                                @if (document.type?.length || document.annotation_count > 0) {
                                <p class="mt-1">
                                    @for (type of document.type; track type) {

                                    <span class="badge rounded-pill bd-bg-green-colour">
                                        <i-bs [name]="iconNames.File"></i-bs>&nbsp;&nbsp;{{type}}&nbsp;&nbsp;
                                    </span>

                                    }
                                    @if (document.annotation_count > 0) {
                                    <span class="badge rounded-pill bd-bg-green-colour">
                                        <i-bs [name]="iconNames.ChatLeftDots"></i-bs> {{document.annotation_count}}
                                    </span>
                                    }
                                </p>
                                }
                            </pdf-viewer>
                        </li>

                        }
                    </ul>
                </td>
            </tr>

            }
        </tbody>
    </table>
</div>
}
<adobe-pdf-viewer></adobe-pdf-viewer>

<ng-template #pluralheading let-values let-heading="heading" let-classes="classes">
    @if (values.length === 1) {
    <h2 class="{{ classes }}">{{ heading }}</h2>
    }
    @if (values.length > 1 && !classes) {
    <h2>{{ heading }}s</h2>
    }
    @if (values.length > 1 && classes) {
    <h2 class="{{ classes }}">{{ heading }}S</h2>
    }
</ng-template>